import { API_FEEDBACK_REQUESTS_PREFIX } from '@shared/config/api/api-prefixes';
import { FeedbackCreateDataRequest, FeedbackCreateDataResponse } from './create-feedback-request-types';
import { feedbackApi } from '@entities/feedback/api/feedback-api';

export const feedbackCreateRequestApi = feedbackApi.injectEndpoints({
    endpoints: (build) => ({
        feedbackCreateRequest: build.mutation<FeedbackCreateDataResponse, FeedbackCreateDataRequest>({
            query: (data) => {
                return {
                    url: API_FEEDBACK_REQUESTS_PREFIX,
                    method: 'POST',
                    body: data,
                };
            },
            invalidatesTags: ['FeedbackSubjectsList'],
        }),
    }),
});

export const { useFeedbackCreateRequestMutation } = feedbackCreateRequestApi;
